module.exports = __webpack_public_path__ + "img/icons-filter-light.52793a51.svg";